import type { CopilotTeachingPopoverProps } from './components/CopilotTeachingPopover';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotTeachingCallout" */ './lazyIndex'),
    { name: 'CopilotTeachingCallout' }
);

export const CopilotTeachingPopover: LazyComponent<CopilotTeachingPopoverProps, any> =
    createLazyComponent(lazyModule, m => m.CopilotTeachingPopover);

export { lightupPrecondition } from './utils/lightupPrecondition';
export { dismissCopilotTeachingPopover } from './utils/dismissCopilotTeachingPopover';
